import React from 'react';

type VideoProps = {
  src: string;
  width?: number;
  height?: number;
  controls?: boolean;
  loop?: boolean;
  autoPlay?: boolean;
  muted?: boolean;
};

const Video = (props: VideoProps) => {
  return (
    <video
      className="rounded-md bg-slate-500/20"
      width={props.width ? props.width : 1920}
      height={props.height ? props.height : 1080}
      controls={props.controls ? props.controls : false}
      preload="metadata"
      loop={props.loop ? props.loop : false}
      autoPlay={props.autoPlay ? props.autoPlay : false}
      muted={props.muted ? props.muted : false}
    >
      <source src={props.src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default Video;
